import { LocationDto } from '../dtos/location.dto';
import { LocationModel } from '../models/location.model';

export class LocationMapper {
  public static toModel(dto: LocationDto): LocationModel {
    return {
      locationId: dto.locationId,
      name: dto.name,
      externalId: dto.externalId,

      senderEmail: dto.emailSettings.senderEmail,
      senderName: dto.emailSettings.senderName,

      street: dto.contact.street,
      zipCode: dto.contact.zipCode,
      city: dto.contact.city,
      country: dto.contact.country,
      phone: dto.contact.phone,
      mobile: dto.contact.mobile,
      emailAddress: dto.contact.emailAddress,
      homePageUrl: dto.contact.homePageUrl,

      maxAdvanceBookingDays: dto.bookingSettings.maxAdvanceBookingDays,
      minFutureBookingHours: dto.bookingSettings.minFutureBookingHours,
      minAdvanceCancellationHours: dto.bookingSettings.minAdvanceCancellationHours,
      minGroupAppointmentAdvanceCancellationHours: dto.bookingSettings.minGroupAppointmentAdvanceCancellationHours,
      maxGroupAppointmentsPerWeek: dto.bookingSettings.maxGroupAppointmentsPerWeek,
      maxAppointmentsPerWeek: dto.bookingSettings.maxAppointmentsPerWeek,
      maxAppointmentsTotal: dto.bookingSettings.maxAppointmentsTotal,
      maxAppointmentFrequency: dto.bookingSettings.maxAppointmentFrequency,
      startTimeIntervalMinutes: dto.bookingSettings.startTimeIntervalMinutes,
      startIntervalRelativeToSlot: dto.bookingSettings.startIntervalRelativeToSlot,
      groupAppointmentWithSubscriptionOnly: dto.bookingSettings.groupAppointmentWithSubscriptionOnly,

      minAppAdvanceCancellationHours: dto.appSettings.minAppAdvanceCancellationHours,
      appCanCancelAppointment: dto.appSettings.appCanCancelAppointment,
      onlineBookingUrls: dto.appSettings.onlineBookingUrls ?? [],

      hideAnyTherapist: dto.appearanceSettings.hideAnyTherapist,
      imageUrl: dto.appearanceSettings.imageUrl,
      hideBookingWarning: dto.appearanceSettings.hideBookingWarning,
      primaryColor: dto.appearanceSettings.primaryColor,
      secondaryColor: dto.appearanceSettings.secondaryColor,
      tertiaryColor: dto.appearanceSettings.tertiaryColor,
      bookingHint: dto.appearanceSettings.bookingHint ?? [
        { language: 'en', value: undefined },
        { language: 'de', value: undefined },
        { language: 'fr', value: undefined },
        { language: 'it', value: undefined }
      ],
      warnOnTherapistChange: dto.appearanceSettings.warnOnTherapistChange,

      applyColorsToEmails: dto.emailSettings.applyColorsToEmails,
      useCompanyAsSender: dto.emailSettings.useCompanyAsSender,
      confirmationText: dto.emailSettings.confirmationText ?? [
        { language: 'en', value: undefined },
        { language: 'de', value: undefined },
        { language: 'fr', value: undefined },
        { language: 'it', value: undefined }
      ],
      preferredLanguage: dto.emailSettings.preferredLanguage,
      suppressPatientEmails: dto.emailSettings.suppressPatientEmails,
      emailNotificationSettings: dto.emailSettings.emailNotificationSettings
    };
  }

  public static toDto(model: LocationModel): LocationDto {
    return {
      locationId: model.locationId,
      name: model.name,
      externalId: model.externalId,

      contact: {
        street: model.street,
        zipCode: model.zipCode,
        city: model.city,
        country: model.country,
        phone: model.phone,
        mobile: model.mobile,
        emailAddress: model.emailAddress,
        homePageUrl: model.homePageUrl
      },

      bookingSettings: {
        maxAdvanceBookingDays: model.maxAdvanceBookingDays,
        minFutureBookingHours: model.minFutureBookingHours,
        minAdvanceCancellationHours: model.minAdvanceCancellationHours,
        minGroupAppointmentAdvanceCancellationHours: model.minGroupAppointmentAdvanceCancellationHours,
        maxGroupAppointmentsPerWeek: model.maxGroupAppointmentsPerWeek || undefined,
        maxAppointmentsPerWeek: model.maxAppointmentsPerWeek || undefined,
        maxAppointmentsTotal: model.maxAppointmentsTotal || undefined,
        maxAppointmentFrequency: model.maxAppointmentFrequency,
        startTimeIntervalMinutes: model.startTimeIntervalMinutes,
        startIntervalRelativeToSlot: model.startIntervalRelativeToSlot,
        groupAppointmentWithSubscriptionOnly: model.groupAppointmentWithSubscriptionOnly
      },

      appSettings: {
        minAppAdvanceCancellationHours: model.minAppAdvanceCancellationHours,
        appCanCancelAppointment: model.appCanCancelAppointment,
        onlineBookingUrls: (!model.onlineBookingUrls || model.onlineBookingUrls.length == 0) ? undefined : model.onlineBookingUrls
      },

      appearanceSettings: {
        hideAnyTherapist: model.hideAnyTherapist,
        imageUrl: model.imageUrl,
        hideBookingWarning: model.hideBookingWarning,
        primaryColor: model.primaryColor,
        secondaryColor: model.secondaryColor,
        tertiaryColor: model.tertiaryColor,
        bookingHint: (!model.bookingHint || model.bookingHint.length == 0) ? undefined : model.bookingHint,
        warnOnTherapistChange: model.warnOnTherapistChange
      },

      emailSettings: {
        applyColorsToEmails: model.applyColorsToEmails,
        useCompanyAsSender: model.useCompanyAsSender,
        confirmationText: (!model.confirmationText || model.confirmationText.length == 0) ? undefined : model.confirmationText,
        preferredLanguage: model.preferredLanguage,
        suppressPatientEmails: model.suppressPatientEmails,
        emailNotificationSettings: model.emailNotificationSettings,
        senderEmail: model.senderEmail,
        senderName: model.senderName,
      }
    };
  }
}
